// This gives named constants to the Vessel data properties.
const VesselProperty = {
	NAME: "name",
	IMO: "imo",
	MMSI: "mmsi",
	TIMESTAMP: "timestamp",
	CLASSIFICATION: "classification",
	FLAG: "flag",
	DRAUGHT: "draught",
	SPEED: "speed",
	VOYAGE_DESTINATION: "voyageDestination",
	VOYAGE_ETA: "voyageEta",
	COURSE: "course",
	HEADING: "heading",
	UPDATE: "update",
	CREATED_AT: "createdAt",
	STATIC_UPDATE_AT: "nameOrFlagChangedTimestamp",
	CALL_SIGN: "callSign",
	WIDTH: "width",
	LENGTH: "length",
	SPIRE_ID: "spireId",
	EXTRA: "extra"
};
export default VesselProperty;
